module.exports = __webpack_public_path__ + "media/images/pic/brodno/team/teachers/magdalena-roman-8fee52c98bba815148725746d2a73cf1.png";